import {createApi} from "@reduxjs/toolkit/query/react"
import {setUser} from "../app/slices/sessionSlice"
import {authBaseQuery} from '../app/axiosBaseQuery'
import {User} from "../types/auth.d"

const CURRENT_USER_API_REDUCER_KEY = 'current-users';
export const CURRENT_USER_PATH = 'current-users';

export const currentUserApi = createApi({
    reducerPath: CURRENT_USER_API_REDUCER_KEY,
    baseQuery: authBaseQuery(),
    keepUnusedDataFor: 10,
    refetchOnMountOrArgChange: 10,
    refetchOnFocus: true,
    tagTypes: ["Me"],
    endpoints: (builder) => ({
        getMe: builder.query<User, null>({
            query() {

                console.log('getMe query')

                return {
                    url: `/${CURRENT_USER_PATH}/me`,
                };
            },
            providesTags: ['Me'],
            async onQueryStarted(args, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled;
                    await dispatch(setUser(data));
                } catch (error) {
                    console.log('Cannot get user', error)
                }
            },
        }),
    }),
});

export const {
    useGetMeQuery,
} = currentUserApi;

